<template>
  <div class="add-post">
    <uploaderVideo ref="uploadDiv" :uploadType="4" @uploadSucc="handleUploadSucc"></uploaderVideo>
    <!-- <div class="upload-imgs">
      <van-uploader v-model="fileList" :max-count="maxCount" @delete="handleDelImgs" :after-read="handleUpload"/>
    </div> -->
    <div class="upload-title">
      <input type="text" maxlength="50" v-model="subjectName" placeholder="填写标题,会有更多点赞哦~" class="input-title">
    </div>
    <!-- maxlength="50" -->
    <!-- <van-field v-model="content" rows="6" autosize type="textarea" maxlength="100" placeholder="请输入留言" show-word-limit /> -->
    <quill-editor v-model="content" :options="editorOption"></quill-editor>
    <div class="block-flex">
      <div class="flex-label">文件</div>
      <div class="flex-con" v-if="filePdfCon && Object.keys(filePdfCon).length > 0" @click="handleClick">
        <div class="con-txt">{{ `${filePdfCon.title}.${filePdfCon.format}` }}</div>
        <img src="../../assets/images/zone/train_cnacel.png" class="icon-del" @click="handleDelImgs(filePdfCon)" alt="">
      </div>
      <van-uploader v-else accept=".pdf,.ppt,.pptx" :after-read="handleUploadPdf">
        <div class="upload-btn">
          <van-icon name="plus" color="#FFF"></van-icon>
          <span class="btn-txt">添加文件</span>
        </div>
      </van-uploader>
    </div>
    <div class="fixed-btn" :class="{cur: allInput, upload: uploadPost }" @click="handleAddPost">提交
    </div>
    <van-overlay :show="showAnswerLoading">
      <div class="wrapper-loading" @click.stop>
        <van-loading type="spinner" vertical>上传中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { uploadPathFile, answerWork, workDetails, updateAnswerWork } from '@/api/zone'
import uploaderVideo from './compontents/uploaderVideo.vue'
import { allVideo, toolbarOptions, roleIsTutor } from './data'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    uploaderVideo,
    quillEditor
  },
  data () {
    return {
      content: '',
      subjectName: '',
      form: {},
      postId: '', // 专区Id
      filePdfCon: {},
      fileIds: [],
      editorOption: {
        modules: {
          toolbar: toolbarOptions
        },
        theme: 'snow',
        placeholder: '请输入内容...'
      },
      maxSize: 200 * 1024 * 1024,
      uploadPost: false,
      contentMaxLength: 1000,
      showAnswerLoading: false
    }
  },
  computed: {
    allInput () {
      return this.subjectName.length > 0 && this.content.length > 0
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    let role = JSON.parse(sessionStorage.getItem('roleResult'))
    if (roleIsTutor(role, this.userInfo)) {
      this.$router.push({
        path: `/zoneDetails?areaId=${this.$route.query.areaId}`
      })
      return
    }
    this.postId = this.$route.query.postId
    if (this.$route.query.workId) {
      workDetails({ workId: this.$route.query.workId }).then(res => {
        this.detailData = res.data
        this.iepUserDTO = this.detailData.iepUserDTO
        this.content = res.data.content
        this.subjectName = res.data.title
        this.fileList = res.data.files.filter(item => {
          if (item.format === 'pdf' || item.format.indexOf('ppt') > -1) {
            this.filePdfCon = item
            this.pdfIds = [item.id]
          } else {
            this.fileIds.push(item.id)
          }
          return item.format !== 'pdf' && item.format.indexOf('ppt') < 0
        })
        if (this.fileList.length === 1 && allVideo.indexOf((this.fileList[0].format).toLocaleLowerCase()) > -1) {
          this.$refs.uploadDiv.videoObj = this.fileList[0]
          this.$refs.uploadDiv.fileList = []
          this.$refs.uploadDiv.isUpload = true
        } else {
          this.$refs.uploadDiv.fileList = this.fileList
        }
        this.$refs.uploadDiv.fileIds = this.fileIds
        this.$refs.uploadDiv.uploadList = this.fileList
      })
    }
  },
  methods: {
    handleClick () {
      // this.$router.push({
      //   path: `/pdfView?pdfUrl=${this.filePdfCon.url}`
      // })
    },
    handleUploadPdf (respon) {
      if (respon.file.size > this.maxSize) {
        this.$toast(`文件大小不能超过 ${this.maxSize / 1024 / 1024}M`)
        return false
      }
      this.showAnswerLoading = true
      // type: 1发帖2投票3直播预估4代办任务(作业)
      if (respon.file.type.indexOf('pdf') > -1 || respon.file.name.indexOf('ppt') > -1) {
        let formData = new FormData()
        formData.append('type', '4')
        formData.append('mainId', '')
        formData.append('file', respon.file)
        uploadPathFile(formData).then(res => {
          this.pdfIds = [res.data.id]
          if (res.data.format === 'pdf' || res.data.filename.indexOf('ppt') > -1) {
            this.filePdfCon = res.data
          }
          this.showAnswerLoading = false
        })
      } else {
        this.$toast('只允许上传PDF或PPT文件！')
      }
    },
    getPlainTextLen(richText) {
      return richText
        .replace(/<[^>]+>/g, '')
        .replace(/ |\n|\r\n|&nbsp;|&ensp;/g, '')
        .replace(/[a-zA-Z]&#7([6-7][0-9]);/g, ' ')
        .replace(/&([a-z]{2,5}|#[0-9]{1,6});/g, ' ')
        .length
    },
    handleAddPost () {
      if (!this.allInput) {
        this.$toast('请输入内容')
        return
      }
      if (this.getPlainTextLen(this.content) > this.contentMaxLength) {
        this.$toast('字数超过1000！')
        return
      }
      if (this.uploadPost) return
      this.uploadPost = true
      if (this.$route.query.workId) {
        this.handleUpdate()
        return
      }
      let params = {
        postbarId: this.postId,
        userId: this.userInfo.id,
        content: this.content,
        title: this.subjectName,
        kind: '1',
        fileIds: this.fileIds.concat(this.pdfIds)
      }
      answerWork(params).then(res => {
        this.$toast('发布成功')
        setTimeout(() => {
          this.$router.push({
            path: `/zoneDetails?areaId=${this.$route.query.areaId}`
          })
        }, 1500)
      }).catch((err) => {
        this.$toast(err.msg)
        this.uploadPost = false
      })
    },
    handleUpdate () {
      if (!this.allInput) {
        this.$toast('请输入内容')
        return
      }
      let params = {
        workId: this.$route.query.workId,
        userId: this.userInfo.id,
        content: this.content,
        title: this.subjectName,
        kind: '1',
        fileIds: this.fileIds.concat(this.pdfIds)
      }
      updateAnswerWork(params).then(res => {
        this.$toast('编辑成功')
        setTimeout(() => {
          this.$router.push({
            path: `/workDetails?workId=${this.$route.query.workId}&workType=answer&areaId=${this.$route.query.areaId}`
          })
        }, 1500)
      }).catch((err) => {
        this.$toast(err.msg)
        this.uploadPost = false
      })
    },
    handleDelImgs (file) {
      if (file.format === 'pdf' || file.format.indexOf('ppt') > -1) {
        this.filePdfCon = {}
      }
      this.pdfIds = []
      // this.fileIds = this.fileIds.filter(res => res.id !== file.id)
    },
    handleUploadSucc (succon) {
      this.fileList = succon.uploadList
      this.fileIds = this.fileIds.concat(succon.uploadList.map(item => item.id))
      this.videoObj = succon.videoObj
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.add-post {
padding-bottom: 90px;
box-sizing: border-box;
  .upload-imgs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 16px 14px;
    box-sizing: border-box;

    /deep/ .van-uploader__wrapper {
      .van-uploader__preview,
      .van-image,
      .van-uploader__upload {
        width: 109px;
        height: 109px;
        margin-right: 10px;

        &:nth-child(3n) {
          margin-right: 0;
        }
      }

      .van-uploader__upload-icon {
        font-size: 36px;
      }
    }
  }

  .upload-title {
    width: 100%;
    border-top: 1px solid #E8E8E8;
    box-sizing: border-box;
    padding: 0 14px;
    box-sizing: border-box;

    .input-title {
      line-height: 55px;
      height: 55px;
      border: none;
      border-bottom: 1px solid #E8E8E8;
      font-weight: 600;
      outline: none;
      background-color: transparent;
      width: 100%;
      font-size: 18px;
      color: #282828;

      &::placeholder {
        color: #C0C0C2;
      }
    }
  }

  /deep/ .van-field__control {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.80);

    &::placeholder {
      color: #C0C0C2;
    }
  }

  .block-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;
    border-top: 1px solid #E8E8E8;
    border-bottom: 1px solid #E8E8E8;
    box-sizing: border-box;
    margin: 0 14px;
    margin-top: 20px;

    .flex-label {
      font-size: 14px;
      color: #343434;
      font-weight: 500;
    }

    .flex-con {
      display: flex;
      align-items: center;

      .con-txt {
        white-space: nowrap;
        overflow: hidden;
        width: 240px;
        text-overflow: ellipsis;
      }

      .icon-del {
        width: 12px;
        display: block;
        margin-left: 6px;
      }
    }

    /deep/ .van-icon {
      color: #7A8494;
    }

    .upload-btn {
      display: flex;
      align-items: center;
      width: 81px;
      height: 22px;
      justify-content: center;
      border-radius: 30px;
      color: #FFF;
      background: #EB1700;

      .btn-txt {
        font-size: 14px;
      }
    }
  }

  .fixed-btn {
    position: fixed;
    bottom: 24px;
    left: 14px;
    width: calc(100vw - 28px);
    height: 42px;
    border-radius: 100px;
    background-color: #E6E6E6;
    font-size: 16px;
    color: #AEAEAE;
    text-align: center;
    line-height: 42px;
    font-weight: 500;

    &.upload {
      color: #fff;
      background-color: #C0C0C0;
    }

    &.cur {
      color: #fff;
      background-color: #EB1700;
    }
  }
}
.wrapper-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/answerWork.vue